import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiShow, ApiUser, ShowsApi } from '@tytapp/api';
import { BillingService } from '@tytapp/billing';
import { DialogComponent, NamedDialog, Transfer } from '@tytapp/common';
import { environment } from '@tytapp/environment';
import { isServerSide } from '@tytapp/environment-utils';
import { HostApi } from '@tytapp/common';
import { UserService } from '@tytapp/user';

@NamedDialog('podcast')
@Component({
    selector: 'app-podcast',
    templateUrl: './podcast.component.html',
    styleUrls: ['./podcast.component.scss']
})
export class PodcastComponent extends DialogComponent implements OnInit {
    private userService = inject(UserService);
    private billing = inject(BillingService);
    private showApi = inject(ShowsApi);
    private hostApi = inject(HostApi);
    private matSnackBar = inject(MatSnackBar);

    get pageComponentId() {
        return 'podcast-dialog';
    }

    async init(id: string) {
        // iOS somehow ends up with the dialog component reloading
        // when the user hits the back button. Problem is, we have
        // no parameters available. For most cases it is appropriate to
        // just close the dialog.

        if (!id) {
            this.close();
            return;
        }

        this.subscribe(this.billing.entitlementChanged, entitled => this.entitled = entitled);
        this.subscribe(this.userService.userChanged, user => {
            this.user = user;
            this.updatePodcastUrl();
        });

        this.show = await this.showApi.get(id).toPromise() as ApiShow;
        this.updatePodcastUrl();
    }

    get billingEnabled() {
        return this.hostApi.capabilities.includes('web_billing:membership')
            || this.hostApi.capabilities.includes('platform_billing:membership');
    }

    get joinUrl() {
        return `/join/membership`;
    }

    updatePodcastUrl() {
        if (!this.user || !this.show)
            return;

        this.podcastUrl = `${environment.urls.platform}/podcasts/premium/${this.user.uuid}/shows/${this.show.id}`;
        this.androidPodcastUrl = `https://subscribeonandroid.com/${this.podcastUrl.replace(/^https?:\/\//g, '')}`;

        // TODO: podcast URLs
    }

    @ViewChild('urlField')
    urlField: ElementRef;

    @Transfer()
    show: ApiShow;

    @Transfer()
    user: ApiUser;

    @Transfer()
    entitled = false;

    @Transfer()
    podcastUrl: string;

    @Transfer()
    androidPodcastUrl: string;

    copyUrl() {
        if (isServerSide())
            return;

        this.urlField.nativeElement.select();
        if (environment.isNativeBuild && document.documentElement.classList.contains('ios-os')) {
            navigator.clipboard.writeText(this.urlField.nativeElement.value);
        } else {
            document.execCommand?.('copy');
        }

        this.notify(
            'The podcast URL has been copied to your clipboard. Paste it into your favorite podcasting application.'
        );
    }

    notify(message: string) {
        this.matSnackBar.open(message, undefined, { duration: 3000 });
    }

    selectAll(target: EventTarget) {
        if (target instanceof HTMLInputElement)
            target.select();
    }
}
